import {div, p, img, h1, h3, i} from '@hyperapp/html';

export default function Lightbox({firstName, lastName, title, imageMed, bio, dispatch}) {
  return div({
    id: 'lightbox-background',
    onclick: () => dispatch({type: 'close_bio_lightbox'})
  }, [
    div({ id: 'lightbox-body', onclick: e => e.stopPropagation() }, [
      i({
        className: 'fas fa-times-circle',
        onclick: () => dispatch({type: 'close_bio_lightbox'})
      }),
      div([
        div({ className: 'employee-bio-image' }, [
          img({ src: imageMed })
        ]),
        div({ className: 'employee-bio-body' }, [
          h1(`${firstName} ${lastName}`),
          p(title),
          h3({
            oncreate(el){
              el.innerHTML = bio.reduce((a,c) => {
                return `${a}${c}`;
              }, "");
            }
          })
        ])
      ])
    ])
  ]);
}